export var ProgressBarThresholdIndicatorColor;
(function (ProgressBarThresholdIndicatorColor) {
    ProgressBarThresholdIndicatorColor["LIGHT"] = "LIGHT";
    ProgressBarThresholdIndicatorColor["DARK"] = "DARK";
})(ProgressBarThresholdIndicatorColor || (ProgressBarThresholdIndicatorColor = {}));
//# sourceMappingURL=ProgressBarThresholdIndicatorColor.js.map